import { PageShell, ProcessSection } from "@/components/sections";

const Process = () => (
  <PageShell testId="process-page">
    <ProcessSection />
  </PageShell>
);

export default Process;
